<!--loader-->
<div class="bg-opacity" *ngIf="isSpinnerVisible">
    <div class="parent parent-landingpage">
       <div class="spin1"></div>
    </div>
 </div>
 <!--loaderend-->